import Layout from '@/Layout';
import Router from "next/router";
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setSmarticoLoginContinue } from "../../store/thunk/gameThunk";
import { gameActions } from '../../store/gameSlice';

export const smarticoDeepLink = "/rewards-centre";
function index() {
    const userCenter = useSelector((state) => state.userCenter);
    const dispatch = useDispatch();
  const [isLogin, setIsLogin] = useState(false);
  const boxexData = [
    {
      iconSrc: "/vn/img/otherPageBanner/coins.svg",
      desc: "Kiểm tra Điểm thưởng một cách đơn giản."
    },{
      iconSrc: "/vn/img/otherPageBanner/newDesign.svg",
      desc: "Nâng cấp tất cả nền tảng Trải nghiệm sự liền mạch."
    },{
      iconSrc: "/vn/img/otherPageBanner/newCart.svg",
      desc: "Thiết kế Trang Giải Thưởng cải tiến."
    },{
      iconSrc: "/vn/img/otherPageBanner/newPurchase.svg",
      desc: "Đổi quà và thưởng ngay lập tức và dễ dàng."
    },{
      iconSrc: "/vn/img/otherPageBanner/newGames.svg",
      desc: "Các lượt chơi minigame có thể đổi thưởng sớm."
    },
  ]

  useEffect(() => {
    global.Pushgtagpiwikurl &&
    global.Pushgtagpiwikurl(
        "rewards-store",
        "Rewards Store"
    );}, []);

    useEffect(() => {
        if(userCenter?.memberInfo?.memberCode && userCenter?.memberInfo?.memberCode !== "") {
            setIsLogin(true);
        }
        
        },[userCenter?.memberInfo?.memberCode]);

  const Bonx = ({iconSrc, desc}) => {
    return (
      <div style={{display: "flex", flexDirection:"column", alignItems:"center", marginBottom: "20px"}}>
        <img src={iconSrc} alt="icon" style={{width: "50px", height: "50px"}}/>
        <p style={{marginLeft: "10px", marginTop:"8px"}}>{desc}</p>
      </div>
    )
  }

  return (
      <Layout status={1}>
          <div
              style={{
                  width: "100%",
                  minHeight: "1117px",
              }}
          >
              <div>
                  <img
                      src="/vn/img/otherPageBanner/VN_rewardbanner_desktop.jpg"
                      alt="smarticoEntry"
                      style={{ width: "100%" }}
                  />
              </div>
              <div
                  style={{
                      width: "100%",
                      textAlign: "center",
                  }}
              >
                  <div
                      style={{
                          width: "100%",
                      }}
                  >
                      <p
                          style={{
                              fontWeight: 600,
                              fontSize: "28px",
                              color: "#222222",
                              marginTop: "40px",
                          }}
                      >
                          Trang Giải Thưởng hiện đã khả dụng tại Sảnh Thưởng!
                      </p>
                      <p
                          style={{
                              fontWeight: 400,
                              fontSize: "20px",
                              color: "#666666",
                              marginTop: "20px",
                          }}
                      >
                          Tận hưởng trải nghiệm nhận quà và đổi thưởng mượt mà hơn tại Fun88!
                      </p>
                  </div>
                  <div
                      style={{
                          width: "100%",
                      }}
                  >
                      <p
                          style={{
                              fontWeight: 600,
                              fontSize: "24px",
                              color: "#222222",
                              marginTop: "40px",
                          }}
                      >
                           Tính năng mới đặc biệt
                      </p>
                      <div
                          style={{
                              width: "100%",
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              marginTop: "28px",
                          }}
                      >
                          {boxexData.map((item, index) => {
                              return (
                                  <div
                                      key={index}
                                      style={{
                                          width: "208px",
                                          padding: "10px",
                                      }}
                                  >
                                      <Bonx
                                          iconSrc={item.iconSrc}
                                          desc={item.desc}
                                      />
                                  </div>
                              );
                          })}
                      </div>
                  </div>
                  <div
                      style={{
                          width: "100%",
                          marginTop: "60px",
                      }}
                  >
                      <h3>Khám phá Trang Giải Thưởng hoàn toàn mới ngay hôm nay và tận dụng tối đa phần thưởng của bạn!</h3>
                  </div>
                  <div>
                      <img
                          onClick={() =>{
                            if(!isLogin) {
                                dispatch(setSmarticoLoginContinue(true));
                                dispatch(gameActions.smarticoLoginContinueWithDeepLink(true))
                                global.goUserSign("1");
                                return
                            }
                            Pushgtagdata(
                                "RewardsStore",
                                "Go to Rewards Centre",
                                "RewardsStore_C_Exchange",
                            );
                            Router.push(smarticoDeepLink);
                          }
                          }
                          src="/vn/img/otherPageBanner/Button.svg"
                          alt="smarticoEntry"
                          style={{
                              width: "278px",
                              height: "56%",
                              cursor: "pointer",
                              marginTop: "52px",
                          }}
                      />
                  </div>
                  <div
                  style={{
                    marginTop: "52px",
                  }}
                  >
                      Chi tiết, truy cập {" "}
                      <span
                          style={{
                              color: "#00A6FF",
                              cursor: "pointer",
                              textDecoration: "underline",
                          }}
                          onClick={() =>{
                            Pushgtagdata(
                                "RewardsStore",
                                "GO to Help Center",
                                "RewardsStore_C_HelpCenter",
                            );
                            window.open('/vn/customer-service')
                            }
                          }
                      >
                          Trung Tâm Trợ Giúp
                      </span>
                  </div>
              </div>
          </div>
      </Layout>
  );
}

export default index